import { FavoriteBorderOutlined } from "@mui/icons-material"
import { Box, Grid, Tooltip, Typography } from "@mui/material"
import { healthBarColors } from "../../themes/common"
import { StyledPaper } from "../commons"

export interface HealthFactorType {
  title: string
  health: number
}

const HealthFactorStats = (props: HealthFactorType) => {
  const { title, health } = props
  const healthStatus = health > 5 ? 'healthy' : health > 1.5 ? 'risky' : 'danger'
  const riskyBarColor = health > 1.5 ? healthBarColors[healthStatus] : 'text.disabled'
  const healthyBarColor = health > 5 ? healthBarColors[healthStatus] : 'text.disabled'
  const healthFactorDisplay = (Math.trunc(health * 10) / 10).toFixed(Math.trunc(health * 10) / 10 >= 10 ? 0 : 2) //dont round off

  const healthBarAnimation = (color: string) => {
    let boxShadowSetting = `0px 0px 16px 0px ${color}`
    let boxShadowSettingEnd = `0px 0px 6px 0px ${color}`
    let animationSetting = `glow 2s ease-in-out infinite alternate`
    return {
      animation: animationSetting,
      // boxShadow: `0px 0px 14px 0px ${healthBarColors[healthStatus]}`,
      '@keyframes glow': {
        "0%": {
          boxShadow: boxShadowSetting
        },
        "100%": {
          boxShadow: boxShadowSettingEnd
        }
      }
    }
  }

  return (
    <Grid item sx={{ width: '100%' }}>
      <StyledPaper color='primary' sx={{
        padding: { xs: '0.5rem 1rem', sm: '1rem 1.5rem' },
        minWidth: { xs: '8.7rem', sm: '20rem' },
        maxWidth: { xs: '100%', sm: '100%' },
        minHeight: { xs: '5rem', sm: '6rem' },
        borderRadius: 1
      }}>
        <Grid container flexDirection={'column'} gap={1}>
          <Grid item container justifyContent={"space-between"}>
            <Tooltip title={'Your Health Factor represents the overall stability of your loan. It is calculated by comparing the value of your total deposits with your total debt. Your Health Factor is also influenced by your Loan-to-Value (LTV) ratio. A higher Health Factor indicates a lower risk of liquidation, reflecting a more secure position relative to your loan and collateral.'}
              content={'Your Health Factor represents the overall stability of your loan. It is calculated by comparing the value of your total deposits with your total debt. Your Health Factor is also influenced by your Loan-to-Value (LTV) ratio. A higher Health Factor indicates a lower risk of liquidation, reflecting a more secure position relative to your loan and collateral.'}>
              <Typography variant="body6" color='text.secondary' sx={{
                textDecoration: 'underline dotted',
                textUnderlineOffset: 4,
                cursor: 'pointer'
              }}>
                {title}
              </Typography>
            </Tooltip>
            <FavoriteBorderOutlined fontSize="small" sx={{ color: `${healthBarColors[healthStatus]}` }} />
          </Grid>
          <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item xs={4} sm={3}>
              <StyledPaper color='primary' sx={{
                padding: { xs: '0rem', sm: '0.2rem 0.4rem' },
                width: { xs: '2.5rem', sm: '3.1rem' },
                borderRadius: 1.33,
                textAlign: 'center'
              }}>
                <Typography variant='body5' color={`${healthBarColors[healthStatus]}`}>
                  {healthFactorDisplay}
                </Typography>
              </StyledPaper>
            </Grid>
            <Grid item xs={6} sm={9} container spacing={0.75} flexWrap={'nowrap'} sx={{
              // boxShadow: '0px 0px 8px 0px #23FFB080'
              minWidth: '6rem'
            }}>
              <Grid xs={3} sm={2} item>
                <Box id="healthbar" sx={{
                  backgroundColor: `${healthBarColors[healthStatus]}`,
                  width: '100%', height: '0.4rem',
                  borderTopLeftRadius: 8,
                  borderBottomLeftRadius: 8,
                  ...healthBarAnimation(healthBarColors[healthStatus])
                }} />
              </Grid>
              <Grid xs={4} sm={4} item>
                <Box id="healthbar" sx={{
                  backgroundColor: `${riskyBarColor}`,
                  width: '100%', height: '0.4rem',
                  // boxShadow: `0px 0px 14px 0px ${riskyBarColor}`,
                  ...healthBarAnimation(riskyBarColor)
                }} />
              </Grid>
              <Grid xs={5} sm={6} item>
                <Box id="healthbar" sx={{
                  backgroundColor: `${healthyBarColor}`,
                  width: '100%', height: '0.4rem',
                  borderTopRightRadius: 8,
                  borderBottomRightRadius: 8,
                  // boxShadow: `0px 0px 14px 0px ${healthyBarColor}`,
                  ...healthBarAnimation(healthyBarColor)
                }} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default HealthFactorStats